/**
 * The logo.
 *
 * The mark is the third-tone contour — the same dipping curve the app draws
 * under every block and stamps on the app icon — sitting above two water lines.
 * Read as pitch it is a tone; read as a silhouette it is a shoreline with a bay.
 * That double reading is the whole idea, and it means the identity is built from
 * something the app actually teaches rather than a decoration bolted on top.
 */

export function LogoMark({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      role="img"
      aria-label="Language Island"
    >
      <rect width="48" height="48" rx="11" fill="var(--ink-900)" />

      {/* Third tone, 214: falls, holds low, then rises. */}
      <path
        d="M9 22 Q17 30 24 30 T39 12"
        stroke="var(--cinnabar)"
        strokeWidth="4.4"
        strokeLinecap="round"
        fill="none"
      />

      {/* Water. Uneven lengths so it reads as sea rather than as a rule. */}
      <path
        d="M12 37h11M27 37h9M9 42h7M20 42h14"
        stroke="var(--celadon)"
        strokeWidth="2.2"
        strokeLinecap="round"
        opacity="0.75"
      />
    </svg>
  )
}

export function Logo({ size = 40, brand = '语言岛' }: { size?: number; brand?: string }) {
  return (
    <span className="logo">
      <LogoMark size={size} />
      <span className="logo-words">
        <span className="logo-zh">{brand}</span>
        <span className="logo-en">Language Island</span>
      </span>
    </span>
  )
}
